
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/estimate/new",
      function () {
        return require("private-next-pages/estimate/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/estimate/new"])
      });
    }
  